<template>
  <div class="dash-alert">
    <div class="icon">
      <slot name="icon">
        <img
          src="@/assets/images/common/error-outline-white.svg"
          alt="Error Icon"
        />
      </slot>
    </div>
    <div class="message text-white">
      <slot name="message" />
    </div>
    <div class="alert-cta" v-if="showCta">
      <slot name="cta">
        <b-button variant="white" size="lg" :to="{ name: 'invoices' }">
          {{ $t('common.alert.viewInvoices') }}
        </b-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showCta: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';

.alert-cta {
  flex-shrink: 0;

  .btn {
    font-size: 1.2rem;
    color: #4a4a4a;
    line-height: 1.2rem;
    padding: 1rem 2rem;
    border-width: 0;
  }
}

.icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.message {
  padding: 0 1rem 0 1.5rem;
  flex-grow: 1;
  font-size: 24px;
  line-height: 28px;
  font-weight: 300;
  display: flex;
  align-items: center;
}

.dash-alert {
  border-radius: $border-radius;
  background: $danger;
  display: flex;
  padding: 1.2rem;
  margin-bottom: 1rem;
  &.warning {
    background: $warning;
  }
}
</style>
